 
'use client'
import { useFormStatus } from 'react-dom'
import BaseSubmitButton from './BaseSubmitButton'
import type { BaseSubmitButtonProps } from './BaseSubmitButton'
function SubmitButton({ disabled: disabled_, ...props }: Omit<BaseSubmitButtonProps, 'busy'>) {
  const { pending: busy } = useFormStatus()
  const disabled = disabled_ || busy
  return <BaseSubmitButton {...(props as BaseSubmitButtonProps)} disabled_={disabled} busy={busy} />
}
export default SubmitButton
